import { superstyled } from '@zenbusiness/zui/styles';

import OneColumnLayout from '#client/layouts/OneColumnLayout';

export const CartErrorRoot = superstyled({
  name: 'CartError',
  slot: 'Root',
  tag: OneColumnLayout,
  styles: ({ theme }) => ({
    [theme.breakpoints.up('sm')]: {
      maxWidth: 546,
      margin: 'auto'
    }
  })
});
